
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/units",
      function () {
        return require("private-next-pages/info/units/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/units"])
      });
    }
  